import { useTranslations } from '@lang';
import { FC } from 'react';
import NoSSR from 'react-no-ssr';
import { TimeSlotType } from 'shared-types/SpaPackage';
import { BlockSelectField } from '../FormElements';
import { SelectToggleButton } from '../ToggleButton';

import {
  CaretDownIcon,
  OptionRow,
  OptionTitleStyle,
  RightAlignedDiv,
} from './OptionSelector.style';

export type DropdownType = {
  value: string;
  label: string;
};

type FieldInput = {
  value: any;
  onChange: (value: any) => void;
};

type FieldMeta = {
  submitFailed?: boolean;
  error?: string;
};

type OptionSelectorProps = {
  optionTitle?: string | JSX.Element;
  timeslots?: TimeSlotType[];
  supportsSelections?: boolean;
  disabled: boolean;
  requireTimeSlots: boolean;
  input: FieldInput;
  meta: FieldMeta;
};

const setTimeSlotsValues = (timeslots) =>
  timeslots?.map((timeslot) => ({
    ...timeslot,
    value: timeslot.startTime,
    label: timeslot.startTime.split(':').slice(0, 2).join(':'),
  }));

export const OptionSelector: FC<OptionSelectorProps> = ({
  optionTitle,
  timeslots,
  supportsSelections,
  disabled,
  requireTimeSlots,
  input,
  meta,
}) => {
  const { t } = useTranslations();
  const { value, onChange } = input;

  const { isSelected = false, timeslot, configurationGroupId, optionId } = value || {};

  const onChangeSelected = (value: boolean) =>
    onChange({
      configurationGroupId,
      optionId,
      isSelected: value,
      timeslot,
    });
  const onChangeTimeslot = (value: string) =>
    onChange({
      configurationGroupId,
      optionId,
      isSelected,
      timeslot: value,
    });

  return (
    <OptionRow isSelected={isSelected} requireTimeSlots={requireTimeSlots}>
      <OptionTitleStyle>{optionTitle}</OptionTitleStyle>
      <RightAlignedDiv requireTimeSlots={requireTimeSlots}>
        {supportsSelections && (
          <SelectToggleButton
            isDisabled={disabled}
            input={{
              onChange: onChangeSelected,
              value: isSelected,
            }}
          />
        )}
        {timeslots && requireTimeSlots && (
          <NoSSR>
            <BlockSelectField
              options={setTimeSlotsValues(timeslots)}
              placeholder={`${t('aria.optionSelectorDropdownPlaceholder')}...`}
              components={{
                IndicatorSeparator: () => null,
                DropdownIndicator: () => <CaretDownIcon className="dropdownIcon" />,
              }}
              onChange={onChangeTimeslot}
              value={timeslot}
              isDisabled={disabled}
              label=""
              error={meta.submitFailed && meta.error}
            />
          </NoSSR>
        )}
      </RightAlignedDiv>
    </OptionRow>
  );
};
